import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';

import { attachmentContentTypeShape, optionShape } from '../../prop-types';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import { flash } from '../../utils/flash';
import AttachmentForm from '../AttachmentForm';
import { CONTENT_TYPE_TO_ATTACHMENT_TYPES } from '../constants';

const endpoint = api.addAttachment;

class AddAttachment extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      type: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const { onRequest, onSuccess, loading, contentType, objectId } = this.props;

    const { type } = this.state;

    if (loading) return; // only make one request at a time

    const meta = { type, contentType, objectId };

    onRequest(meta)
      .then(files => {
        onSuccess(files[0].response.body); // This module supports only single file uploads
        flash('Attachment uploaded successfully');
      })
      .catch(console.error); // eslint-disable-line no-console
  }

  handleTypeChange(event) {
    this.setState({ type: event.target.value });
  }

  render() {
    const attachmentTypes =
      this.props.attachmentTypes ||
      CONTENT_TYPE_TO_ATTACHMENT_TYPES[this.props.contentType];

    return (
      <AttachmentForm
        type={this.state.type}
        attachmentTypes={attachmentTypes}
        uploader={endpoint.uploader}
        onTypeChange={this.handleTypeChange}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

AddAttachment.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
  onSuccess: func.isRequired,
  contentType: attachmentContentTypeShape.isRequired,
  objectId: number.isRequired,
  attachmentTypes: arrayOf(optionShape.isRequired),
};

AddAttachment.defaultProps = {
  attachmentTypes: undefined,
};

export default withApiRequest({
  query: endpoint,
})(AddAttachment);
